<template>
  <div class="catalogList">
  <div class="catalogList__container">
    <MainPreloader
        v-if="loading"
        position="fixed"
        :size="80"
        :stroke="3"
    />
      <shop-card
          class="catalogList__shopCard"
          v-for="card in pageData"
          :key="card.id"
          :item="card"
      ></shop-card>
  </div>
    <table-pager
        v-if="shopPagination.countPages.value > 1 || shopPagination.hasMoreData.value"
        :pagination="shopPagination"
    ></table-pager>

  </div>
</template>

<script>

import usePagination from "@/composables/pagination";
import {useShopStore} from "@/store/shop";
import {onMounted} from "vue";
import ShopCard from "@/components/CatalogView/ShopCard.vue";
import TablePager from "@/components/shared/TablePager.vue";
import MainPreloader from "@/components/shared/MainPreloader.vue";

export default {
  name: "CatalogList",
  components: {MainPreloader, TablePager, ShopCard},
  setup() {
    const shopStore = useShopStore();
    const shopPagination = usePagination(shopStore, 20, false);

    onMounted(async () => {
      await shopStore.clearData();
      await shopPagination.initLoad();
    })

    return {
      shopPagination,
      ...shopPagination
    }
  }
}
</script>


<style scoped lang="scss">
.catalogList {
  display: flex;
  flex-direction: column;
  gap: 20px;
  &__container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    &__shopCard {
      cursor: pointer;
    }
  }
}
</style>
